import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import EmailingController from "../../controller/EmailingController/EmailingController";
import CompanySetupController from "../../../SuperAdmin/Controller/Client/SACompanyListController";
import { handleChange, handleSubmit } from "../../controller/EmailingController/CreateEmailingController";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import HelpSite from "../../../Common/HelpLink";
function EmailNotification({ activeTab }) {
    const { t } = useTranslation(); // Hook to access translations
    const navigate = useNavigate();
    const [formData, setFormData] = useState({ NotificationEmailFrom: '', IsNotificationSend: '0', AppPassword: "", SMTPServer: "", port: "", InboxEmailClientID: "", InboxEmailTenantID: "", InboxEmailClientSecret: "" });
    const [EmailList, setEmailing] = useState([]);
    const [errors, setErrors] = useState({});
    const { theme } = useContext(ThemeContext);
    const [checkboxState, setCheckboxState] = useState({});
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }

    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;
        setCheckboxState({ ...checkboxState, [name]: checked });

        // Update the formData state
        setFormData({
            ...formData,
            [name]: checked, // Store true/false for checkbox
        });
    };
    async function fetchCompanySetup() {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const ClientID = localStorage.getItem('CompanyID');
            const companySetup = await CompanySetupController.GetCompanyByID(redirectCallback, ClientID);
            setFormData({
                NotificationEmailFrom: companySetup[0].NotificationEmailFrom, IsNotificationSend: parseInt(companySetup[0].IsNotificationSend), AppPassword: companySetup[0].AppPassword, SMTPServer: companySetup[0].SMTPServer, port: companySetup[0].port,
                InboxEmailClientID: companySetup[0].InboxEmailClientID, InboxEmailTenantID: companySetup[0].InboxEmailTenantID, InboxEmailClientSecret: companySetup[0].InboxEmailClientSecret
            }); // Initialize formData with the fetched data
        } catch (error) {
            console.error('Error fetching Roles:', error);
        }
    }
    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleEditorChange = (content) => {
        setFormData({
            ...formData,
            vc_Value: content
        });
    };

    const handleButtonClick = (value) => {
        setFormData({
            ...formData,
            vc_Value: value
        });
    };

    const fetchEmailing = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            const EmailingList = await EmailingController.GetEmailSetting(redirectCallback);
            debugger;
            setEmailing(EmailingList); // Initialize formData with the fetched data
        } catch (error) {
            console.error('Error fetching email settings:', error);
        }
    };

    const handleRadioChange = async (event, email) => {
        debugger;
        const { value } = event.target;
        const status = value === "Yes" ? 1 : 0;
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        // Update the radio button state locally
        setEmailing((prevEmailList) =>
            prevEmailList.map((item) =>
                item.PK_SettingsValue_ID === email.PK_SettingsValue_ID ? { ...item, Status: status } : item
            )
        );

        try {
            // Make an API call to update the status in the database
            await EmailingController.UpdateEmailStatus(redirectCallback, email.PK_SettingsValue_ID, status);
        } catch (error) {
            console.error('Error updating email status:', error);
        }
    };

    useEffect(() => {
        fetchCompanySetup();
        fetchEmailing();

    }, []);
    const handleFormSubmit = async (event) => {
        event.preventDefault();
        try {
            debugger;
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const redirectUserList = () => {
                navigate('/AdministrationSetting?saved=true');
            };
            formData.ClientID = localStorage.getItem("CompanyID");
            await handleSubmit(event, formData, setFormData, setErrors, redirectCallback, redirectUserList);
            await fetchCompanySetup();
            window.scrollTo(0, 0);
        } catch (error) {
            setErrors({ submit: 'Submission failed. Please try again.' });
            console.error('Error submitting form:', error);
        }
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            <div className="row mb-3">
                <div className="col-sm-12" style={{ "textAlign": "right" }}>
                    <HelpSite FormName="Mail Setting" Module="26" />
                </div>
            </div>
            <form onSubmit={handleFormSubmit}>
                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                    <label htmlFor="CompanyName" className="col-sm-2 col-form-label">Email Notifications</label>
                    <div className="col-sm-10">
                        <div style={{ marginTop: "5px" }}>
                            <input type="checkbox" name="IsNotificationSend" className="form-check-input" onChange={event => handleCheckboxChange(event)} checked={formData.IsNotificationSend == '1'} />
                            <label style={{ "marginLeft": "18px" }} className="form-check-label" htmlFor="EmailNotification">
                                Allow SAM to perform automatic email notifications.
                            </label>
                        </div>
                    </div>
                </div>
                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                    <label htmlFor="inputText" className="col-sm-2 col-form-label">SMTP Server:</label>
                    <div className="col-sm-6">
                        <input type="text" className='form-control' name="SMTPServer" value={formData.SMTPServer || ''} onChange={handleChange} />
                    </div>
                </div>
                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Port:</label>
                    <div className="col-sm-6">
                        <input type="text" className='form-control' name="port" value={formData.port || ''} onChange={handleChange} />
                    </div>
                </div>
                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Email From:</label>
                    <div className="col-sm-6">
                        <input type="text" className='form-control' name="NotificationEmailFrom" value={formData.NotificationEmailFrom || ''} onChange={handleChange} />
                        {errors.NotificationEmailFrom && <div style={{ color: 'red' }}>{errors.NotificationEmailFrom}</div>}
                    </div>
                </div>
                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                    <label htmlFor="inputText" className="col-sm-2 col-form-label">App Password:</label>
                    <div className="col-sm-6">
                        <input type="text" className='form-control' name="AppPassword" value={formData.AppPassword || ''} onChange={handleChange} />
                        {errors.AppPassword && <div style={{ color: 'red' }}>{errors.AppPassword}</div>}
                    </div>
                </div>
                <hr />
                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Tenant ID:</label>
                    <div className="col-sm-6">
                        <input type="text" className='form-control' name="InboxEmailTenantID" value={formData.InboxEmailTenantID || ''} onChange={handleChange} />
                        
                    </div>
                </div>
                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Client ID:</label>
                    <div className="col-sm-6">
                        <input type="text" className='form-control' name="InboxEmailClientID" value={formData.InboxEmailClientID || ''} onChange={handleChange} />
                       
                    </div>
                </div>
                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Client Secret:</label>
                    <div className="col-sm-6">
                        <input type="text" className='form-control' name="InboxEmailClientSecret" value={formData.InboxEmailClientSecret || ''} onChange={handleChange} />
                        
                    </div>
                </div>
                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                    <div className="col-sm-12" style={{ textAlign: "right" }}>
                        <button type="submit" className="btn btn-primary">
                            <i className="icofont-save" aria-hidden="true"> Save

                            </i>
                        </button>

                    </div>
                </div>


            </form>
            <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                <div className="col-sm-12">
                    <table className="table datatable table-bordered" style={{ minHeight: "400px" }}>
                        <thead>
                            <tr>
                                <th style={{ width: "50%" }}>Email Switches</th>
                                <th style={{ width: "50%" }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{ width: "50%" }}>
                                    <table className="table">
                                        {EmailList.map((email, index) => (
                                            <tr key={index} style={{ borderBottom: "1px solid #dee2e6" }}>
                                                <td style={{ width: "40%" }}>{email.vc_ValueName}</td>
                                                <td style={{ width: "35%" }}>
                                                    <input type='hidden' id={`hd_${email.PK_SettingsValue_ID}`} value={email.vc_Value} />
                                                    {email.vc_ValueName != "Invoicing" && email.vc_ValueName != "Purchasing" && email.vc_ValueName != "Quotations" && email.vc_ValueName != "Sales Orders" && (
                                                        <>
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name={`radio${email.vc_ValueName}`}
                                                                id={`radio${email.vc_ValueName}${index}`}
                                                                value="Yes"
                                                                checked={email.Status === 1}
                                                                onChange={(e) => handleRadioChange(e, email)}
                                                            />


                                                            <label style={{ paddingtop: "calc(0rem + 1px);", marginLeft: "20px" }} className="" htmlFor={`radio${email.vc_ValueName}${index}`}>Yes</label>


                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name={`radio${email.vc_ValueName}`}
                                                                id={`radio${email.vc_ValueName}${index}`}
                                                                value="No"
                                                                checked={email.Status === 0}
                                                                onChange={(e) => handleRadioChange(e, email)}
                                                                style={{ marginLeft: "20px" }}
                                                            />
                                                            <label style={{ paddingtop: "calc(0rem + 1px)", marginLeft: "40px" }} className="" htmlFor={`radio${email.vc_ValueName}${index}`}>No</label>
                                                        </>
                                                    )}
                                                </td>
                                                <td style={{ width: "25%" }}>
                                                    <button type="button" style={{ fontSize: "9px" }} id={`btn_${email.PK_SettingsValue_ID}`} className="btn btn-primary btn-sm" onClick={() => handleButtonClick(email.vc_Value)}>Email Template</button>
                                                </td>
                                            </tr>
                                        ))}
                                    </table>
                                </td>
                                <td style={{ width: "50%" }}>
                                    <ReactQuill style={{ width: "100%" }} value={formData.vc_Value || ''} onChange={handleEditorChange} theme="snow" className="custom-quill" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default EmailNotification;
